var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.0825195C6.63599 0.0825195 0.666656 6.05185 0.666656 13.4159C0.666656 20.0705 5.54266 25.5865 11.9173 26.5879V17.2692H8.53066V13.4159H11.9173V10.4785C11.9173 7.13719 13.9067 5.29185 16.9533 5.29185C18.412 5.29185 19.9373 5.55185 19.9373 5.55185V8.83185H18.2573C16.6 8.83185 16.084 9.85985 16.084 10.9145V13.4159H19.7813L19.1907 17.2692H16.084V26.5879C22.4573 25.5879 27.3333 20.0692 27.3333 13.4159C27.3333 6.05185 21.364 0.0825195 14 0.0825195Z",
    fill: "#5243C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.ebb2acb934d1962b5ed127a51f947b57.svg";
export { ForwardRef as ReactComponent };